/* ==========================================================================
   Smoosh — Soap Individual PDP
   Vanilla JS: gallery + accordion + cart adds. (Bubble animation removed.)
   Exposes a small global namespace `window.smooshPDP`.
   ========================================================================== */

(function () {
  'use strict';

  // Same <script src="soap-pdp.js"> tag is included by several sections.
  // The browser executes each tag, so without a guard this IIFE would run
  // 3× and attach 3 sets of click listeners (qty stepper would jump by 3).
  if (window.__smooshPDPLoaded) return;
  window.__smooshPDPLoaded = true;

  /* ===== ADD TO CART (mirrors product-form.js pattern) ===== */
  function addToCart(variantId, qty) {
    const cartDrawer = document.querySelector('cart-drawer');
    const cartUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';

    const formData = new FormData();
    formData.append('id', String(variantId));
    formData.append('quantity', String(qty || 1));

    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      formData.append('sections', cartDrawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      formData.append('sections_url', window.location.pathname);
    }

    return fetch(cartUrl, {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status) {
          console.warn('[smooshPDP] add-to-cart error', response);
          return response;
        }
        /* Publish the theme's cartUpdate event so cart-upsell apps and any
           other subscribers (Junip, Rebuy, complementary modules etc.)
           re-initialize against the new cart state. Theme's product-form.js
           does the same thing. */
        try {
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
              source: 'smoosh-pdp',
              productVariantId: String(variantId),
              cartData: response,
            });
          }
        } catch (e) { /* non-fatal */ }
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          /* If cart was empty before the add, <cart-drawer> still carries
             the .is-empty class. cart-drawer.js:open() checks that class
             on `this` and (when true) looks for .drawer__inner-empty —
             which doesn't exist in the post-add DOM. trapFocus(null) then
             throws, breaking the rest of the open sequence (incl. Swiper
             init). Strip the class proactively so the focus trap targets
             #CartDrawer cleanly. */
          cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents(response);
          /* Re-init the cart-drawer's Swiper upsell AFTER the drawer's
             open transition finishes. Firing earlier (custom.js already
             fires it with only a 100ms internal delay via its fetch
             monkey-patch) measures the drawer mid-transition at ~0 width
             and lays out the broken single-char-per-line track. 600ms
             clears the standard drawer open transition. */
          if (typeof window.refreshUpsellSwiper === 'function') {
            setTimeout(function () {
              try { window.refreshUpsellSwiper(); } catch (e) { /* non-fatal */ }
            }, 600);
          }
        } else {
          // fallback: navigate to /cart
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
        return response;
      })
      .catch(function (err) { console.warn('[smooshPDP] add-to-cart failed', err); });
  }

  /* ===== GALLERY swipe + thumbnails + dots ===== */
  function initGallery(root) {
    if (!root) return;
    const track = root.querySelector('[data-spdp-gallery-track]');
    const slides = Array.from(root.querySelectorAll('[data-spdp-gallery-slide]'));
    const thumbs = Array.from(root.querySelectorAll('[data-spdp-gallery-thumb]'));
    const dots = Array.from(root.querySelectorAll('[data-spdp-gallery-dot]'));
    const counter = root.querySelector('[data-spdp-gallery-counter]');
    const arrows = Array.from(root.querySelectorAll('[data-spdp-gallery-arrow]'));
    const stripContainer = root.querySelector('[data-spdp-gallery-strip]');
    if (!track || slides.length === 0) return;

    let idx = 0;
    let startX = null;
    let dragOffset = 0;

    function setActive(i) {
      idx = Math.max(0, Math.min(slides.length - 1, i));
      const pct = -idx * (100 / slides.length);
      track.style.transition = 'transform 420ms cubic-bezier(.2,.6,.2,1)';
      track.style.transform = 'translateX(' + pct + '%)';
      dots.forEach(function (d, k) {
        if (k === idx) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
      thumbs.forEach(function (t, k) {
        if (k === idx) t.setAttribute('data-active', 'true');
        else t.removeAttribute('data-active');
      });
      if (counter) counter.textContent = (idx + 1) + ' / ' + slides.length;
      if (stripContainer && thumbs[idx]) {
        const t = thumbs[idx];
        const left = t.offsetLeft - (stripContainer.clientWidth - t.clientWidth) / 2;
        stripContainer.scrollTo({ left: left, behavior: 'smooth' });
      }
      arrows.forEach(function (a) {
        const dir = a.getAttribute('data-spdp-gallery-arrow');
        if (dir === 'prev') a.toggleAttribute('disabled', idx <= 0);
        if (dir === 'next') a.toggleAttribute('disabled', idx >= slides.length - 1);
      });
    }

    function onDown(e) { startX = (e.touches ? e.touches[0].clientX : e.clientX); dragOffset = 0; track.style.transition = 'none'; }
    function onMove(e) {
      if (startX == null) return;
      const x = (e.touches ? e.touches[0].clientX : e.clientX);
      dragOffset = x - startX;
      const pct = -idx * (100 / slides.length);
      track.style.transform = 'translateX(calc(' + pct + '% + ' + dragOffset + 'px))';
    }
    function onUp() {
      if (startX == null) return;
      if (Math.abs(dragOffset) > 55) setActive(idx + (dragOffset < 0 ? 1 : -1));
      else setActive(idx);
      startX = null; dragOffset = 0;
    }

    track.addEventListener('mousedown', onDown);
    track.addEventListener('mousemove', onMove);
    track.addEventListener('mouseup', onUp);
    track.addEventListener('mouseleave', function () { if (startX != null) onUp(); });
    track.addEventListener('touchstart', onDown, { passive: true });
    track.addEventListener('touchmove', onMove, { passive: true });
    track.addEventListener('touchend', onUp);

    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { setActive(i); }); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { setActive(i); }); });
    arrows.forEach(function (a) {
      const dir = a.getAttribute('data-spdp-gallery-arrow');
      a.addEventListener('click', function () { setActive(idx + (dir === 'next' ? 1 : -1)); });
    });

    setActive(0);
  }

  /* ===== ACCORDIONS (single-open) ===== */
  function initAccordionGroup(root) {
    if (!root) return;
    const rows = Array.from(root.querySelectorAll('[data-spdp-accordion-row]'));
    const allowMultiple = root.hasAttribute('data-spdp-accordion-multi');

    function open(row) {
      const body = row.querySelector('[data-spdp-accordion-body]');
      const inner = row.querySelector('[data-spdp-accordion-inner]');
      if (body && inner) body.style.setProperty('--spdp-row-h', inner.scrollHeight + 'px');
      row.setAttribute('data-open', 'true');
      const btn = row.querySelector('[data-spdp-accordion-toggle]');
      if (btn) btn.setAttribute('aria-expanded', 'true');
    }
    function close(row) {
      row.setAttribute('data-open', 'false');
      const btn = row.querySelector('[data-spdp-accordion-toggle]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    }

    rows.forEach(function (row) {
      const btn = row.querySelector('[data-spdp-accordion-toggle]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        const isOpen = row.getAttribute('data-open') === 'true';
        if (!allowMultiple) rows.forEach(close);
        if (!isOpen) open(row);
      });
    });
  }

  /* ===== MAIN ATC FORM HANDLER ===== */
  function initMainATC(root) {
    if (!root) return;
    const form = root.querySelector('[data-spdp-atc-form]');
    const qtyEl = root.querySelector('[data-spdp-qty]');
    const qtyDec = root.querySelector('[data-spdp-qty-dec]');
    const qtyInc = root.querySelector('[data-spdp-qty-inc]');
    const atcBtn = root.querySelector('[data-spdp-atc-button]');
    if (!form || !atcBtn) return;

    function getQty() { return Math.max(1, parseInt((qtyEl && qtyEl.textContent) || '1', 10) || 1); }
    function setQty(n) { if (qtyEl) qtyEl.textContent = String(Math.max(1, n)); }

    if (qtyDec) qtyDec.addEventListener('click', function () { setQty(getQty() - 1); });
    if (qtyInc) qtyInc.addEventListener('click', function () { setQty(getQty() + 1); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const variantId = form.getAttribute('data-variant-id');
      if (!variantId) return;
      atcBtn.classList.add('is-loading');
      addToCart(variantId, getQty()).finally(function () {
        atcBtn.classList.remove('is-loading');
      });
    });
  }

  /* ===== QUICK ADD (You May Also Like cards) ===== */
  function initQuickAdds(root) {
    if (!root) return;
    const buttons = Array.from(root.querySelectorAll('[data-spdp-quick-add]'));
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        const variantId = btn.getAttribute('data-spdp-quick-add');
        if (!variantId) return;
        btn.classList.add('is-loading');
        addToCart(variantId, 1).finally(function () {
          btn.classList.remove('is-loading');
        });
      });
    });
  }

  /* ===== BOOT ===== */
  function boot() {
    document.querySelectorAll('[data-spdp-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-spdp-accordion]').forEach(initAccordionGroup);
    document.querySelectorAll('[data-spdp-main-atc]').forEach(initMainATC);
    document.querySelectorAll('[data-spdp-quick-adds]').forEach(initQuickAdds);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.smooshPDP = {
    addToCart: addToCart,
    initGallery: initGallery,
    initAccordionGroup: initAccordionGroup,
    initMainATC: initMainATC,
    initQuickAdds: initQuickAdds,
    boot: boot,
  };
})();
